import { createFeatureSelector, createSelector, MemoizedSelector } from '@ngrx/store';
import { errorFeatureKey, ErrorState } from './error.reducer';

export const selectErrorState: MemoizedSelector<object, ErrorState> =
    createFeatureSelector<ErrorState>(errorFeatureKey);

export const selectError = createSelector(selectErrorState, (state: ErrorState) => state.error);
